export {
	CATEGORY_URL_PATH,
	EVENT_SEARCH_SUBMITTED_TERM_KEY,
	EVENT_SEARCH_TYPE_KEY,
	KEYWORD_PREFIX,
	LANG_CODE_REGEX,
	PRODUCT_URL_PATH,
	SEARCH_TYPE,
	SPANISH_LANG_PREFIX,
} from './constants';
export type { GA4SearchType } from './constants';
export { useTrackSearchResults } from './useTrackSearchResults';
export { useTrackSearchSubmit } from './useTrackSearchSubmit';
export { buildSearchPayload, decodeUrlDestination, getSearchType, getURLSearchType } from './utils';
